function unique(values = []) {
  return Array.from(
    new Set(
      (Array.isArray(values) ? values : [values])
        .map((value) => String(value || "").trim().toLowerCase())
        .filter(Boolean)
    )
  );
}

export const TENANT_GOVERNANCE_PERMISSION_KEYS = Object.freeze({
  settingsView: "tenant.settings.view",
  settingsUpdate: "tenant.settings.update",
  companyDetailsView: "tenant.companydetails.view",
  companyDetailsUpdate: "tenant.companydetails.update",
  modulesView: "tenant.modules.view",
  modulesUpdate: "tenant.modules.update",
  workflowsView: "tenant.workflows.view",
  workflowsUpdate: "tenant.workflows.update",
  integrationsView: "tenant.integrations.view",
  integrationsUpdate: "tenant.integrations.update",
  statusView: "tenant.status.view",
  documentsView: "tenant.documents.view",
  documentsViewOwn: "tenant.documents.viewOwn",
  documentsCreate: "tenant.documents.create",
  documentsCreateOwn: "tenant.documents.createOwn",
  documentsUpdate: "tenant.documents.update",
  documentsUpdateOwnDraft: "tenant.documents.updateOwnDraft",
  documentsSubmitForReview: "tenant.documents.submitForReview",
  documentsArchive: "tenant.documents.archive",
  documentsCustomerPortalPublish: "tenant.documents.customerPortalPublish",
});

export const TENANT_GOVERNANCE_PERMISSION_GROUPS = Object.freeze({
  settingsView: unique([
    TENANT_GOVERNANCE_PERMISSION_KEYS.settingsView,
    "tenants.view",
    "tenants.settings",
  ]),
  settingsUpdate: unique([
    TENANT_GOVERNANCE_PERMISSION_KEYS.settingsUpdate,
    "tenants.settings",
    "settings.edit",
  ]),
  companyDetailsView: unique([
    TENANT_GOVERNANCE_PERMISSION_KEYS.companyDetailsView,
    TENANT_GOVERNANCE_PERMISSION_KEYS.settingsView,
    "tenants.view",
    "tenants.settings",
  ]),
  companyDetailsUpdate: unique([
    TENANT_GOVERNANCE_PERMISSION_KEYS.companyDetailsUpdate,
    TENANT_GOVERNANCE_PERMISSION_KEYS.settingsUpdate,
    "tenants.settings",
    "settings.edit",
  ]),
  modulesView: unique([
    TENANT_GOVERNANCE_PERMISSION_KEYS.modulesView,
    TENANT_GOVERNANCE_PERMISSION_KEYS.settingsView,
    "tenants.view",
    "tenants.settings",
    "settings.edit",
  ]),
  modulesUpdate: unique([
    TENANT_GOVERNANCE_PERMISSION_KEYS.modulesUpdate,
    TENANT_GOVERNANCE_PERMISSION_KEYS.settingsUpdate,
    "tenants.settings",
    "settings.edit",
  ]),
  workflowsView: unique([
    TENANT_GOVERNANCE_PERMISSION_KEYS.workflowsView,
    TENANT_GOVERNANCE_PERMISSION_KEYS.settingsView,
    "tenants.view",
    "tenants.settings",
    "settings.edit",
  ]),
  workflowsUpdate: unique([
    TENANT_GOVERNANCE_PERMISSION_KEYS.workflowsUpdate,
    TENANT_GOVERNANCE_PERMISSION_KEYS.settingsUpdate,
    "tenants.settings",
    "settings.edit",
    "workorders.plan",
  ]),
  integrationsView: unique([
    TENANT_GOVERNANCE_PERMISSION_KEYS.integrationsView,
    TENANT_GOVERNANCE_PERMISSION_KEYS.settingsView,
    "integrations.settings",
    "tenants.view",
    "tenants.settings",
  ]),
  integrationsUpdate: unique([
    TENANT_GOVERNANCE_PERMISSION_KEYS.integrationsUpdate,
    TENANT_GOVERNANCE_PERMISSION_KEYS.settingsUpdate,
    "integrations.settings",
    "tenants.settings",
    "settings.edit",
  ]),
  statusView: unique([
    TENANT_GOVERNANCE_PERMISSION_KEYS.statusView,
    TENANT_GOVERNANCE_PERMISSION_KEYS.settingsView,
    "tenants.view",
    "tenants.settings",
  ]),
  documentsView: unique([
    TENANT_GOVERNANCE_PERMISSION_KEYS.documentsView,
    "tenant.documents.view",
    "workorder.read.mine",
    "workorder.read.detail",
    "workorder.read.all",
    "templates.view",
    "tenants.view",
    "tenants.settings",
  ]),
  documentsViewOwn: unique([
    TENANT_GOVERNANCE_PERMISSION_KEYS.documentsViewOwn,
    TENANT_GOVERNANCE_PERMISSION_KEYS.documentsView,
    "tenant.documents.viewOwn",
    "tenant.documents.view",
  ]),
  documentsCreate: unique([
    TENANT_GOVERNANCE_PERMISSION_KEYS.documentsCreate,
    "tenant.documents.create",
    "tenants.settings",
  ]),
  documentsCreateOwn: unique([
    TENANT_GOVERNANCE_PERMISSION_KEYS.documentsCreateOwn,
    TENANT_GOVERNANCE_PERMISSION_KEYS.documentsCreate,
    "tenant.documents.createOwn",
    "tenant.documents.create",
  ]),
  documentsUpdate: unique([
    TENANT_GOVERNANCE_PERMISSION_KEYS.documentsUpdate,
    "tenant.documents.update",
    "tenants.settings",
  ]),
  documentsUpdateOwnDraft: unique([
    TENANT_GOVERNANCE_PERMISSION_KEYS.documentsUpdateOwnDraft,
    TENANT_GOVERNANCE_PERMISSION_KEYS.documentsUpdate,
    "tenant.documents.updateOwnDraft",
    "tenant.documents.update",
  ]),
  documentsSubmitForReview: unique([
    TENANT_GOVERNANCE_PERMISSION_KEYS.documentsSubmitForReview,
    TENANT_GOVERNANCE_PERMISSION_KEYS.documentsUpdate,
    "tenant.documents.submitForReview",
    "tenant.documents.update",
  ]),
  documentsArchive: unique([
    TENANT_GOVERNANCE_PERMISSION_KEYS.documentsArchive,
    "tenant.documents.archive",
    "tenants.settings",
  ]),
  documentsCustomerPortalPublish: unique([
    TENANT_GOVERNANCE_PERMISSION_KEYS.documentsCustomerPortalPublish,
    "tenant.documents.customerPortalPublish",
    "tenant.documents.customerPortalPublish",
    "tenants.settings",
  ]),
  usersManage: unique(["tenant.users.manage", "users.view", "users.create"]),
  rolesManage: unique(["tenant.roles.manage", "tenant.permissions.manage", "tenants.settings"]),
});
